// Drains the `stowlane-gtm-events` meta tag (written by shared/_gtm_events.html.slim,
// queued server-side by ApplicationController#track_event) into real gtag('event', ...)
// calls.
//
// WHY THIS EXISTS, NOT AN INLINE <script> IN <HEAD>. Turbo Drive does not execute a
// <script> it inserts into <head> during a Visit (fetch+morph) navigation -- only a
// script present in a freshly PARSED document runs. track_event() survives one redirect
// via flash and renders on the NEXT page's <head>; on a Turbo-enabled surface that next
// page is reached via a Visit, not a fresh parse, so a gtag() call sitting directly in
// that partial is inserted into the live DOM and NEVER EXECUTES. Confirmed on the wire
// 2026-09-24 (kanban t_636c7c4b): document.head.innerHTML had the gtag('event',...) text
// after a Turbo visit, but window.dataLayer had no entry for it -- explains why the GA4
// property showed 0 of its 7 configured key events over a 90-day window despite real
// demo signups (and in-app start_trial/purchase) happening.
//
// A <meta> tag DOES survive Turbo's head reconciliation on every navigation (Turbo
// already keeps <title>/CSRF meta tags in sync the same way), so this reads it instead.
// `window.gtag`/`window.dataLayer` are defined once, inline, on true initial page parse
// (shared/_head.html.slim) and persist for the life of the Turbo session -- Turbo never
// reloads that inline stub or the loaded gtag.js/gtm.js <script src> tags between
// visits, so pushing onto dataLayer here is exactly what the real inline call would
// have done.
//
// Read-once: the tag is removed immediately so a navigation that doesn't render a fresh
// one can't re-fire a stale event left over from an earlier page.
export function drainGtmEvents() {
  const meta = document.querySelector('meta[name="stowlane-gtm-events"]');
  if (!meta) return;
  meta.remove();

  let events;
  try {
    events = JSON.parse(meta.content);
  } catch {
    return;
  }
  if (!Array.isArray(events) || typeof window.gtag !== "function") return;

  for (const entry of events) {
    if (!entry || typeof entry !== "object") continue;
    const { event, ...params } = entry;
    if (event) window.gtag("event", event, params);
  }
}
